module.exports = __webpack_public_path__ + "static/referral-tree-7c06fdb4b6a1b715be480e9f9a278e76.png";